import React from "react";
import { GoogleLogo, AppleLogo, CheckCircle } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useCalendarConnections, AppleConnectDialog } from "@/components/CalendarConnections";

function ProviderRow({ id, icon, name, connected, email, onConnect, onDisconnect }) {
  return (
    <section className="rounded-lg border p-4 space-y-3" data-testid={`cal-settings-${id}`}>
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2 font-semibold text-slate-900">{icon} {name}</div>
        {connected && (
          <span className="inline-flex items-center gap-1 text-xs font-semibold text-green-700 bg-green-50 border border-green-200 rounded-full px-2 py-0.5" data-testid={`cal-settings-${id}-badge`}>
            <CheckCircle size={12} weight="fill" /> Collegato
          </span>
        )}
      </div>
      {connected ? (
        <div className="flex items-center justify-between gap-2">
          <span className="text-sm text-slate-600 truncate" data-testid={`cal-settings-${id}-email`}>{email || "Account collegato"}</span>
          <Button variant="outline" size="sm" onClick={onDisconnect} data-testid={`disconnect-${id}`}>Disconnetti</Button>
        </div>
      ) : (
        <Button variant="outline" onClick={onConnect} className="w-full" data-testid={`connect-${id}`}>Collega</Button>
      )}
    </section>
  );
}

export default function CalendarSettingsDialog({ open, onOpenChange }) {
  const { user, appleOpen, setAppleOpen, connectGoogle, disconnectGoogle, disconnectApple, refreshMe } = useCalendarConnections();
  return (
    <>
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="max-w-md" data-testid="calendar-settings-dialog">
          <DialogHeader>
            <DialogTitle>Impostazioni Calendario</DialogTitle>
            <DialogDescription>Collega i tuoi calendari per sincronizzare automaticamente gli appuntamenti.</DialogDescription>
          </DialogHeader>
          <div className="space-y-3">
            <ProviderRow
              id="google" name="Google Calendar" icon={<GoogleLogo size={18} weight="bold" />}
              connected={!!user?.google_calendar_connected} email={user?.google_calendar_email}
              onConnect={connectGoogle} onDisconnect={disconnectGoogle}
            />
            <ProviderRow
              id="apple" name="Apple iCloud" icon={<AppleLogo size={18} weight="fill" />}
              connected={!!user?.apple_calendar_connected} email={user?.apple_calendar_email}
              onConnect={() => setAppleOpen(true)} onDisconnect={disconnectApple}
            />
          </div>
        </DialogContent>
      </Dialog>
      <AppleConnectDialog open={appleOpen} onOpenChange={setAppleOpen} onConnected={refreshMe} />
    </>
  );
}
